<script>
    import { onMount } from 'svelte';
    import * as d3 from 'd3';
    import Project from "./Project.svelte";
    let projectTitle = "TSA Checkpoint Travel Numbers (2020 vs 2019)";
    let projectDescription = "One coffee-filled morning, I was searching around for data related to travel and came across the TSA's throughput data.  It shows the comparison of people moving through US airports this year (2020) as compared to 2019.  It seemed like a simple and interesting dataset to get another look at how COVID has or has not affected travel.  It appears that we are coming back up to some level of a new average of airport travel for this period.  It will be interesting to see if it stays more level (about 1 million below the previous year) or if it begins to climb rapidly as vaccines are rolled out. I used Python (pandas) to clean up the data and export it into a useful format.  Initially, I built this visualization using D3 outside of Svelte.  I wanted to work on creating a nice hover effect on the data to make it easy to compare years.  I have made a few modifications to add it directly to this website but more could be done to the code to use Svelte more appropriately.";


    let el;


    onMount(() => {
      var sectionWidth =document.getElementById('chartHolder').offsetWidth;
      if (sectionWidth>900){
        var sectionWidth =1300;
    var sectionHeight = sectionWidth*0.25;
    var margin = {top: 20, right: 200, bottom: 50, left: 200},
    width = sectionWidth - margin.left - margin.right,
    height = sectionHeight - margin.top - margin.bottom;
    var fontSize ='18px';
    var mtop ="120";
      }
      else
      {
         var sectionWidth =600;
        var sectionHeight = sectionWidth*0.4;
         var margin = {top: 20, right: 150, bottom: 50, left: 100},
        width = sectionWidth - margin.left - margin.right,
        height = sectionHeight - margin.top - margin.bottom;
        var fontSize ='14px';
        var mtop ="80";
      }
    // var sectionHeight = sectionWidth*0.25;


    d3.csv("/data/tsa.csv").then(function(data) {
        var parseTime = d3.timeParse("%m/%d/%Y");
        var formatTime = d3.timeFormat("%b");

        // format the data
      data.forEach(function(d) {
          d.date = parseTime(d.Date);
          d.year1 = +d["2019"];
          d.year2 = +d["2020"];
      });

    data.sort(function(a, b) {
        return a.date - b.date;
      });



    // set the ranges
    var x = d3.scaleTime().range([0, width]);
    var y = d3.scaleLinear().range([height, 0]);

    // define the line
    var valueline = d3.line()
        .x(function(d) { return x(d.date); })
        .y(function(d) { return y(d.year1); });

    var valueline2 = d3.line()
        .x(function(d) { return x(d.date); })
        .y(function(d) { return y(d.year2); });


    var svg = d3.select(".chart")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
    .append("g")
    .attr("transform",
          "translate(" + margin.left + "," + margin.top + ")");

    // This allows to find the closest X index of the mouse:
    var bisect = d3.bisector(function(d) { return d.date; }).left;


    //traveling circle
    var focus = svg.append("g")
        .style("display", "none");


    var lineSvg = svg.append("g");



    // scale the range of the data
  x.domain(d3.extent(data, function(d) { return d.date; }));
  y.domain([0, d3.max(data, function(d) { return d.year1; })]);

  // add the valueline path.
  lineSvg.append("path")
     .data([data])
     .attr("d", valueline)
     .attr('stroke', 'grey')
     .attr("fill","none")
    .style('stroke-width', '0.2px')


    lineSvg.append("path")
     .data([data])
     .attr("d", valueline2)
     .attr('stroke', 'grey')
     .attr("fill","none")
    .style('stroke-width', '0.2px')

  svg.selectAll("dot")
     .data(data)
   .enter().append("circle")
     .attr("r", 3)
     .attr("fill",'grey')
     .attr("cx", function(d) { return x(d.date); })
     .attr("cy", function(d) { return y(d.year1); })


     svg.selectAll("dot")
     .data(data)
   .enter().append("circle")
     .attr("r", 3)
     .attr("fill",'steelblue')
     .attr("cx", function(d) { return x(d.date); })
     .attr("cy", function(d) { return y(d.year2); })

  // add the X Axis
  svg.append("g").style("font-family",'Courier New').style("font-size",fontSize)
      .attr("transform", "translate(0," + height + ")")
      .call(d3.axisBottom(x).tickFormat(formatTime))
  // text label for the x axis
  svg.append("text")
      .attr("transform",
            "translate(" + (width/2) + " ," +
                           (height + margin.top + 25) + ")")
      .style("text-anchor", "middle")
      .style("font-family",'Courier New').style("font-size",fontSize)
      .text("Date");

  // add the Y Axis
  svg.append("g").style("font-family",'Courier New').style("font-size",fontSize)
      .call(d3.axisLeft(y).ticks(5));

      // text label for the y axis
  svg.append("text")
      .attr("transform", "rotate(-90)")
      .attr("y",  - margin.left-5)
      .attr("x",0 - (height / 2))
      .attr("dy", "1em")
      .style("text-anchor", "middle")
      .style("font-family",'Courier New').style("font-size",fontSize)
      .text("Number of People");
  svg.append("text")
    .attr("transform",
            "translate(" + (width) + " ," +
                           (margin.top-5) + ")")
      .style("text-anchor", "middle")
      .style("font-family",'Courier New').style("font-size",fontSize)
      .text("2019");
 svg.append("text")
    .attr("transform",
            "translate(" + (width) + " ," +
                           (height-mtop) + ")")
      .style("text-anchor", "middle")
      .style("font-family",'Courier New').style("font-size",fontSize)
      .text("2020");


// append the circle at the intersection

  focus.append("circle").classed("focusCircle1",true)
      .attr("r", 5)
    focus.append("circle").classed("focusCircle2",true)
      .attr("r", 5)

  focus.append("line")
      .classed("x", true)
      .attr('stroke','black')
      .style('stroke-dasharray',"3,3")

  focus.append("line")
      .classed("x2", true)
      .attr('stroke','black')
      .style('stroke-dasharray',"3,3")

  focus.append("line")
      .classed("y", true)
      .attr('stroke','black')
      .style('stroke-dasharray',"3,3")
  // append the rectangle to capture mouse
  svg.append("rect")
      .attr("width", width)
      .attr("height", height)
      .style("fill", "none")
      .style("pointer-events", "all")
      .on("mouseover", function() { focus.style("display", null); })
      .on("mouseout", function() { focus.style("display", "none"); })
      .on("mousemove", mousemove);


  function mousemove() {
      var x0 = x.invert(d3.pointer(event,this)[0]),
          i = bisect(data, x0, 1),
          d0 = data[i - 1],
          d1 = data[i],
          d = x0 - d0.date > d1.date - x0 ? d1 : d0;

    focus.select("circle.y")
       .attr("transform",
             "translate(" + x(d.date) + "," +
                            y(d.year1) + ")");


    // focus.attr("transform", "translate(" + x(d.date) + "," + y(d.year1) + ")");
    focus.select("line.x")
        .attr("x1", 0)
        .attr("x2", x(d.date))
        .attr("y1",  y(d.year1))
        .attr("y2", y(d.year1))
    focus.select("line.x2")
        .attr("x1", 0)
        .attr("x2", x(d.date))
        .attr("y1", y(d.year2))
        .attr("y2", y(d.year2))
    focus.select("line.y")
        .attr("x1", x(d.date))
        .attr("x2", x(d.date))
        .attr("y1", y(d.year1))
        .attr("y2", height)
    focus.select("circle.focusCircle1")
        .attr("cx",x(d.date))
        .attr("cy", y(d.year1))
    focus.select("circle.focusCircle2")
        .attr("cx",x(d.date))
        .attr("cy", y(d.year2))



  }


});


});
</script>
<Project projectTitle = {projectTitle} projectDescription={projectDescription}>
<section id='chartHolder'>

<div >
    <svg class ="chart"></svg>
</div>
<a href='https://www.tsa.gov/coronavirus/passenger-throughput?page=1'>Original Data</a>.
</section>
</Project>

<style>
.chart :global(div){

}
section{background-color: white; overflow-x: scroll;}
svg{
    padding: 75px;
     background-color: white;
    color:black;


}
.axis path,
.axis line {
  fill: none;
  stroke: #000;
  shape-rendering: crispEdges;
  stroke-width:3px;
}

.axis {font-family: 'Courier New', monospace;
    font-size: 16px; color:black;}




.focus {
  opacity: 0.7;
}

.focus circle {
  fill: none;
  stroke: black;
  stroke-width:3px;
}

.focus line {
  fill: none;
  stroke: black;
  stroke-width: 1.5px;
  stroke-dasharray: 3 3;
}




</style>